// extracted by mini-css-extract-plugin
export default {"advertCardList":"c-a_gN","advertCardList_max6":"c-a_gO"};